<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item>物业管理</el-breadcrumb-item>
      <el-breadcrumb-item>房间管理</el-breadcrumb-item>
    </el-breadcrumb>

    <el-form :inline="true" :model="formInline" class="user-search">
      <el-form-item label="搜索：">
        <el-input size="small" v-model="formInline.roomName" placeholder="输入房间名称"></el-input>
      </el-form-item>
      <el-form-item>
        <el-input size="small" v-model="formInline.username" placeholder="输入用户姓名"></el-input>
      </el-form-item>
      <el-form-item v-if="user.username == 'admin'" label="选择部门">
         <el-select v-model="formInline.depId" placeholder="请选择部门"  size="small">
            <el-option
              v-for="item in deptList"
              :key="item.id"
              :label="item.departmentName"
              :value="item.id">
            </el-option>
          </el-select>
      </el-form-item>

      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
        <el-button size="small" type="primary" icon="el-icon-plus" @click="handelAdd">添加</el-button>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="success"   style="margin-left: 10px;"  icon="el-icon-download" :loading="downloadLoadin" @click="exportdata">账单导出</el-button>
      </el-form-item>
    </el-form>

   <el-table  :header-cell-style="this.$store.state.headerCss" size="small" :data="dataList" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中"
    style="width: 100%;"  stripe :max-height="tableHeight">
      <el-table-column align="center" type="index" width="60">
      </el-table-column>

      <el-table-column  prop="roomName" label="房间名称" show-overflow-tooltip>
      </el-table-column>
    		<el-table-column  prop="username" label="用户名称" show-overflow-tooltip>
      </el-table-column>
      <el-table-column  prop="phoneNumber" label="用户手机号" width="130" >
      </el-table-column>
      <el-table-column  prop="powerBlance" label="电费余额"  show-overflow-tooltip>
      </el-table-column>

      <el-table-column  prop="waterBalance" label="水费余额"  show-overflow-tooltip>
      </el-table-column>

      <el-table-column  prop="propertyFeeBalance" label="物业费余额" show-overflow-tooltip>
      </el-table-column>
      <el-table-column  prop="roomArea" label="房屋面积"  min-width="100" show-overflow-tooltip>

      </el-table-column>
     <el-table-column align="center" label="操作" width="350">
        <template slot-scope="scope">
          <prems-button size="mini"   perms="p:detail" @click="handleEdit(scope.row)" label="编辑" />
          <prems-button size="mini" type="danger"  perms="p:delete" @click="deleteInfo(scope.row)" label="删除" />
          <prems-button size="mini" type="primary"  perms="p:cz" @click="handleRecharge(scope.$index, scope.row,'1')" label="充值" />
          <prems-button size="mini" type="warning"   perms="p:cz" @click="handleRecharge(scope.$index, scope.row,'2')" label="退款" />
       <!--   <el-button size="mini" @click="handleEdit(scope.row)">编辑</el-button>
          <el-button size="mini" type="danger"    @click="deleteInfo(scope.row)">删除</el-button>
          <el-button size="mini" type="primary"   @click="handleRecharge(scope.$index, scope.row,'1')">充值</el-button>
          <el-button size="mini" type="warning"   @click="handleRecharge(scope.$index, scope.row,'2')">退款</el-button> -->
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="formInline" @callFather="callFather" v-if="showPage"></Pagination>



    <el-dialog :title="title" :visible.sync="editFormVisible" width="35%" @click="editFormVisible = false" :close-on-click-modal="false">
    	<el-form label-width="120px" :model="editForm" :rules="rules" ref="editForm">
        <el-form-item v-if="user.username == 'admin'" label="选择部门">
           <el-select v-model="editForm.depId" placeholder="请选择部门"  size="small">
              <el-option
                v-for="item in deptList"
                :key="item.id"
                :label="item.departmentName"
                :value="item.id">
              </el-option>
            </el-select>
        </el-form-item>
    		<el-form-item label="房间名称" prop="roomName">
    			<el-input size="small" v-model="editForm.roomName" auto-complete="off" placeholder="请输入房间名称"></el-input>
    		</el-form-item>
    		<el-form-item label="房间大小(㎡)" prop="roomArea">
    			<el-input size="small" v-model="editForm.roomArea" type="number" auto-complete="off" placeholder="请输入房间大小"></el-input>
    		</el-form-item>

        <el-form-item  label="选择计量点" prop="meterInfoId">
          <el-select  filterable v-model="editForm.meterInfoId" placeholder="请选择计量点"  size="small">
             <el-option
                v-for="item in meterList"
                :key="item.id"
                :label="item.meterPointName"
                :value="item.id">
              </el-option>
            </el-select>
        </el-form-item>

    	</el-form>
    	<div slot="footer" class="dialog-footer">
    		<el-button size="small" @click="editFormVisible = false">取消</el-button>
    		<el-button size="small" type="primary" :loading="setLoading" class="title" @click="submitForm('editForm')">保存</el-button>
    	</div>
    </el-dialog>


    <!-- 充值界面 -->
    <el-dialog :title="rtitle" :visible.sync="rechargeFormVisible" width="30%" @click="rechargeFormVisible = false" :close-on-click-modal="false">
    	<el-form label-width="120px" :model="reditForm" :rules="crules" ref="reditForm">
        <el-form-item label="充值类型:">
          <el-select size="small" v-model="reditForm.roomType" @change="changeType">
            <el-option value="63" label="水费"></el-option>
            <el-option value="64" label="物业费"></el-option>
          </el-select>
        </el-form-item>
    		<el-form-item label="房间名称:">
    			<div>{{dForm.roomName}}</div>
    		</el-form-item>
    		<el-form-item label="当前余额:" prop="blance">
    			<div>{{dForm.blance}}</div>
    		</el-form-item>

    		<el-form-item  label="交易类型">
    			<el-select size="small" v-model="reditForm.payType" >
    				<el-option v-for="type in payType" :label="type.label" :value="type.value" :key="type.value" v-if="rtitle != '退款' || type.value !='7'"  ></el-option>
    			</el-select>
    		</el-form-item>
    		<el-form-item  label="交易用户">
    			<el-tag size="small">{{dForm.userName}}</el-tag>
    		</el-form-item>
    		<el-form-item label="充值金额" prop="totalFee" v-if="rtitle == '充值'">
    			<el-input size="small" v-model="totalFee" type="number"   placeholder="请输入充值金额" ></el-input>
    		</el-form-item>
    		<el-form-item label="退款金额" prop="totalFee" v-if="rtitle == '退款'">
    			<el-input size="small" v-model="totalFee" type="number" placeholder="请输入退款金额" ></el-input>
    		</el-form-item>


    		<el-form-item  label="交易备注">
    			<el-input
    			  type="textarea"r
    			  autosize
    			  placeholder="请输入备注"
    			  v-model="reditForm.mark">
    			</el-input>
    		</el-form-item>
    	</el-form>
    	<div slot="footer" class="dialog-footer">
    		<el-button size="small" @click="rechargeFormVisible = false">取消</el-button>
    		<el-button size="small" type="primary" :loading="saveLoad" class="title" @click="subRechargeForm('reditForm')">保存</el-button>
    	</div>
    </el-dialog>

  </div>
</template>

<script>
  import Pagination from '../../components/Pagination'
  import PremsButton from "@/views/permission/PreButtom";
  import { getDepartmentTerminalInfoLis,findMeterInfoList } from '../../api/energyMG'
  import {
    findAllMeterInfoList,
    deleteRoom,
    addRoom,
    findAllRoomList,
    updateRoom,
    roomRecharge,
    generateWaterAndPropertyMonthlyBill,
    roomRefund
  } from '../../api/payMG.js'

  export default {
    data() {

      var validatePass = (rule, value, callback) => {
      	if (this.totalFee == "") {
      		let msg = this.rtitle == '充值'?'请输入充值金额':'请输入退款金额'
      		callback(new Error(msg));
      	} else {
      		if( this.rtitle == '退款'){

            let bmoney = this.reditForm.roomType == 63 ? this.money.water : this.money.wuYe

      			if( this.totalFee > bmoney){
      				return callback(new Error('退款金额不能大于当前余额'));
      			}
      		}
      		callback();
      	}
      };
      return {
        formInline: {
          depId:'',
          pageSize:10,
          currentPage:1,
          total:0,
          meterInfoName:"",
          username:"",
          phoneNumber:"",
          roomName:"",
        },
        downloadLoadin:false,
        saveLoad:false,
        crules:{
        	totalFee: [{
        		validator: validatePass,
        		trigger: 'blur'
        	}],
        },
        totalFee:"",
        users:[],
        editForm:{
          depId:"",
          roomName:"",
          roomArea:"",
          meterInfoId:""
        },

        meterList:[],

        mForm:{
          terIds:JSON.stringify([]),
          currentPage: 1,
          pageSize: 999999,
        },

        pageparm:{

        },
        rtitle:"",
        rechargeFormVisible:false,
        setLoading:false,
        tableHeight:0,
        title:"",
        loading:false,
        meterPointName:"",
        editFormVisible:false,
        dataList:[],
        deptList:[],
        user:{},
        showPage:true,
        reditForm: {
        	totalFee:"",
        	appletUserId:'',
          roomId:"",
        	mark:"",
          roomType:"63",
          payType:'2',
        },
        dForm:{
          roomName:"",
          userName:'',
          blance:"",

        },
        money:{
          water:'',
          wuYe:"",
        },
        payType:[
        	{ value:'2',label:"转账"},
        	{ value:'3',label:"POS"},
        	{ value:'7',label:"多还少补"},
        	{ value:'6',label:"其他"},
        	{ value:'1',label:"现金"},
          { value:'4',label:"支付宝"},
          { value:'5',label:"微信"},
        ],
        rules: {
        	roomName: [{required: true,message: '请输入房间名称',trigger: 'blur'}],
          roomArea: [{required: true,message: '请输入房间大小',trigger: 'blur'}],
          meterInfoId: [{required: true,message: '请选择计量点',trigger: 'change'}],

        	// roomNum:[{validator:validatePass,trigger:'change' }]

        },
      }
    },
    mounted(){
      this.$nextTick(() => {
      	this.tableHeight = window.innerHeight - 300
      })
    },
    created(){
      this.user = JSON.parse(sessionStorage.getItem('userdata'))
      this.depId = JSON.parse(sessionStorage.getItem('userdata')).departmentId
      if(this.user.username != 'admin'){
         this.formInline.depId = JSON.parse(sessionStorage.getItem('userdata')).departmentId
         this.editForm.depId = JSON.parse(sessionStorage.getItem('userdata')).departmentId
      }

      this.getJzData()
      this.getData()

    },
    components: {
      Pagination,
      PremsButton
    },
    methods:{
      exportdata(){

        // if(this.formInline.depIp == ''){
        //   this.$message.
        // }
      	this.downloadLoadin = true

      	let param = {
      		depId:this.formInline.depId
      	}
      	generateWaterAndPropertyMonthlyBill(param).then(res => {
      		var blob = new Blob([res], {type: 'application/vnd.openxmlformats-  officedocument.spreadsheetml.sheet;charset=utf-8'}); //type这里表示xlsx类型
      		var downloadElement = document.createElement('a');
      	　　var href = window.URL.createObjectURL(blob); //创建下载的链接
      	　　downloadElement.href = href;
      	　　downloadElement.download = 'result.xls'; //下载后文件名
      	　　document.body.appendChild(downloadElement);
      	　　downloadElement.click(); //点击下载
      	　　document.body.removeChild(downloadElement); //下载完成移除元素
      	　　window.URL.revokeObjectURL(href); //释放掉blob对象
      		this.downloadLoadin = false
      		this.$message.success('表格生成成功！正在下载')
      	}).catch(err => {
      		this.downloadLoadin = false
      		this.$message({
      			message:'下载失败！',
      			type:'error',
      			showClose:true
      		})
      	})
      },

      handleRecharge(index,row,type){
      	this.rechargeFormVisible = true
        this.reditForm.roomType = '63'
      	this.rtitle = type == "1"?'充值':'退款'
      	this.reditForm.mark = ''

      	if (row != undefined && row != 'undefined') {

      		this.reditForm.appletUserId = row.appletUserId
      		this.dForm.blance = row.waterBalance
          this.dForm.userName = row.username
          this.dForm.roomName = row.roomName
      		this.reditForm.roomId = row.id
      		this.totalFee = ""
          this.money.water = row.waterBalance
          this.money.wuYe = row.propertyFeeBalance
      	}
      },

      changeType(e){
        if(this.reditForm.roomType == '63'){
          this.dForm.blance = this.money.water
        }else{
           this.dForm.blance = this.money.wuYe
        }
      },

      subRechargeForm(editData) {

      	this.$refs[editData].validate(valid => {
      		if (valid) {
      			this.$confirm('确定执行'+this.rtitle+'操作吗?', '信息', {
      			confirmButtonText: '确定',
      			cancelButtonText: '取消',
      			type: 'warning'
      		}).then(() => {
            this.reditForm.totalFee = this.totalFee

      			if( this.rtitle == "充值" ){
      				this.rayCheck()
      			}else{
      				this.brefund();
      			}
      		})
      		} else {
      			return false
      		}
      	})
      },

      //充值
      rayCheck(){
      	this.saveLoad = true
      	this.rtitle = "充值"

        console.log(this.reditForm)


      	roomRecharge(this.reditForm).then( res => {
      		this.saveLoad = false
      		if (res.status == 1) {
      			this.rechargeFormVisible = false
      			this.getData()
      			this.$message({
      				type: 'success',
      				message: '充值成功！'
      			})
      		} else {
      			this.rechargeFormVisible = false
      			this.$message({
      				type: 'info',
      				message: res.msg
      			})
      		}
      	})
      	.catch(err => {
      		this.rechargeFormVisible = false
      		this.saveLoad = false
      		this.$message.error('操作失败，请稍后再试！')
      	})
      },
      	//退款
      brefund(index,row){
      	this.saveLoad = true
      	this.rtitle = "退款"

      	roomRefund(this.reditForm).then( res => {
      		this.saveLoad = false
      		if (res.status == 1) {
      			this.rechargeFormVisible = false
      			this.getData()
      			this.$message({
      				type: 'success',
      				message: '退款成功！'
      			})
      		} else {
      			this.rechargeFormVisible = false
      			this.$message({
      				type: 'info',
      				message: res.msg
      			})
      		}
      	})
      	.catch(err => {
      		this.rechargeFormVisible = false
      		this.saveLoad = false
      		this.$message.error('操作失败，请稍后再试！')
      	})

      },

      getData(){
        this.loading = true
        findAllRoomList(this.formInline).then(res => {
          this.loading = false
          if(res.status == 1){
            this.dataList = res.data.data
            this.formInline.total = res.data.totalCount

          }else{
            this.$message.error(res.msg)
          }
        })
      },
      handelAdd(){
        this.editFormVisible = true
        this.title = '添加'
        this.editForm.id = ""
        this.editForm.roomName = ''
        this.editForm.roomArea = ''
        this.editForm.meterInfoId = ''
      },

      handleEdit(row){
        this.title = '编辑'

        this.editFormVisible = true
        this.editForm.id = row.id
        this.editForm.roomName = row.roomName
        this.editForm.roomArea = row.roomArea
        this.editForm.meterInfoId = row.meterInfoId

      },
      search(){
        this.getData()
      },
      callFather(parm){
        this.formInline.currentPage = parm.currentPage
        this.formInline.pageSize = parm.pageSize
        this.getData()
      },

      deleteInfo(row){
        this.$confirm('确定要删除吗?', '信息', {
        		confirmButtonText: '确定',
        		cancelButtonText: '取消',
        		type: 'warning'
        	})
        	.then(() => {
        		// 删除
        		deleteRoom({
        				id: row.id
        			})
        			.then(res => {
        				if (res.status == 1) {
        					this.$message({
        						type: 'success',
        						message: '已删除!'
        					})
        					this.getData()
        				} else {
        					this.$message({
        						type: 'info',
        						message: res.msg
        					})
        				}
        			})
        			.catch(err => {
        				this.loading = false
        				this.$message.error('删除失败，请稍后再试！')
        			})
        	})
        	.catch(() => {
        		this.$message({
        			type: 'info',
        			message: '已取消删除！'
        		})
        	})
      },
      getMeterInfoList() {
      	this.loadMeter = true
      	let param = {
      		meterPointName: this.meterPointName,
      		energyType:15,
      		priceConfigId:this.curPriceId
      	}
      	findAllMeterInfoList(param).then(res => {
      		this.loadMeter = false
      		if (res.status == 1) {

      			this.MeterInfoList = res.data

      			//this.setChoisMeter(row)
      		} else {
      			this.$message({
      				type: 'info',
      				message: res.msg
      			})
      		}
      	})
      	.catch(err => {
      		this.loadMeter = false
      		this.$message.error('获取数据失败，请稍后再试！')
      	})

      },
      getJzData:function(){
      	return new Promise((resolve,reject) => {
      		getDepartmentTerminalInfoLis().then(res => {
      			this.treeLoad = false
      			if(res.status == 1){
      				let arr = []
      				this.deptList = res.data.menuDepList
              res.data.terIds.forEach( item => {
              	arr.push({ id: item})
              })
              this.mForm.terIds = JSON.stringify(arr)
              this.getMeterList();
      			}
      			else{
      				this.$message.error(res.msg)
      			}
      		})
      	})

      },

      getMeterList(){
        findMeterInfoList(this.mForm).then(res => {
        	if(res.status == 1){
        		this.meterList = res.data.data

        	}else{
        		this.loading = false
        		this.$message.error(res.msg)
        	}
        })
        .catch( err =>{
        	this.loading = false
        	this.$message.error(err)
        })
      },

      submitForm(){

        this.$refs['editForm'].validate(valid => {

        	if(valid){
            if(this.title == '添加'){
              this.add()
            }else{
              this.update()
            }
          }
        })


      },

      add(){
        addRoom(this.editForm).then(res => {
          if(res.status == 1){
            this.editFormVisible = false
            this.$message.success("操作成功")
            this.getData();
          }else {
            this.$message.error(res.msg)
          }
        })
      },
      update(){
        updateRoom(this.editForm).then(res => {
          if(res.status == 1){
            this.editFormVisible = false
            this.$message.success("操作成功")
            this.getData();
          }else {
            this.$message.error(res.msg)
          }
        })
      }
    }
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/property/Property.vue